import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class QueryHelper  {
    _originalTypeClassName = "zAppDevManager.BO.QueryHelper";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
QueryHelper.translate = translateService;
}
this.QueryHelperKey = null;
this._key = this.QueryHelperKey = 0; 
}

static translate: TranslateService;
_key: any;
private _QueryHelperKey:any;
get QueryHelperKey(): any {
    return this._QueryHelperKey;
  }
set QueryHelperKey(value: any) {
    this._QueryHelperKey = value;
    this._key = value;
  }

static EncloseColumn(tableName: any,columnName: any,env: any): any{if (env?.Type == Domain.DBType.MYSQL_LIKE) {return "`" + tableName + "`.`" + columnName + "`";}else {return "[" + tableName + "].[" + columnName + "]";}
}
static FormatDate(date: any): any{if (date != null && (new Date(date).getTime()) > (new Date().getTime()) && (new Date(date).getTime()) > (new Date(moment(-8640000000000000).toDate()).getTime())) {return "'" + CLMS.Framework.DateTime.ToString(date, "yyyy-MM-dd HH:mm:ss.fff") + "'";}
return "NULL";
}
static GetSqlBool(val: any): any{return (val ? 1 : 0);
}
static GetSqlInt(val: any): any{if (CLMS.Framework.Number.Equal(() => val, () => null)) {return "NULL";}
return val?.toString();
}
static SafeParseInt(val: any): any{try {return Joove.Common.cast(val, "number");}
catch (e) {}
return null;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.QueryHelperKey == null || $this.QueryHelperKey == 0;
            }


}